import {alias, createModelSchema} from "serializr";
import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {SmartOfferBundleMarketType} from "./SmartOfferBundleMarketType";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";


export class SmartOfferBundleMarket extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.MARKET);

        this._type = null;

        this._currency = null;
        this._reward = null;
    }

    get type() {
        return this._type;
    }

    set type(value) {
        this._type = value;
    }

    get currency() {
        return this._currency;
    }

    set currency(value) {
        this._currency = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }


    valid() {

        if (!SmartOfferBundleMarketType.is(this.type) || SmartOfferBundleMarketType.isNone(this.type)) {
            return false;
        }

        if (!CurrencyKindModel.is(this.currency)) {
            return false;
        }

        if (!this.reward || !this.reward.valid()) {
            return false;
        }

        return super.valid();
    }

    empty() {

        if (!this.reward || this.reward.empty()) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleMarket());
        } else if (target instanceof SmartOfferBundleMarket) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleMarket, {
    _type: alias("type", SmartOfferBundleMarketType.schema()),
    _currency: alias("currency", CurrencyKindModel.schema()),
    _reward: alias("reward", RewardBunch.schema())
});